// @ts-strict-ignore
import {Component, ContentChildren, Input, OnInit, TemplateRef} from "@angular/core";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {Translations} from "@translations";
import {Header, Marker} from "@common/components/panels/panel/panel.component";

/**
 * @deprecated use sim-panel instead
 */
@Component({
	selector: "sim-old-panel",
	templateUrl: "./old-panel.component.html",
	styleUrls: ["./old-panel.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class OldPanelComponent implements OnInit {
	T = Translations;

	@Input() openable: boolean = true;
	@Input() editMenue: boolean = true;
	@Input() panels: any[];
	@Input() panelOptions;
	@Input() draggable: boolean = false;

	@ContentChildren(Marker, {read: TemplateRef}) templates: any;
	@ContentChildren(Header, {read: TemplateRef}) templatesHeader: any;
	@Input() showControls: boolean = true;

	ngOnInit(): void {}

	openPanel(index: number) {
		if (this.openable) {
			let someOpen = false;
			if (this.panelOptions.activePanel >= 0 && this.panelOptions.activePanel < this.panels.length) {
				this.panels[this.panelOptions.activePanel].open = false;
				someOpen = true;
			}
			if (this.panelOptions.activePanel !== index) {
				this.panelOptions.activePanel = index;
				if (someOpen) {
					setTimeout(() => {
						this.panels[this.panelOptions.activePanel].open = true;
					}, 251);
				} else {
					this.panels[this.panelOptions.activePanel].open = true;
				}
			} else {
				this.panelOptions.activePanel = -1;
			}
		}
	}

	drop(event: CdkDragDrop<string[]>) {
		if (event.isPointerOverContainer) {
			console.log("activePanel:" + this.panelOptions.activePanel);
			console.log("previousIndex:" + event.previousIndex);
			console.log("currentIndex:" + event.currentIndex);
			if (this.panelOptions.activePanel === event.previousIndex) {
				this.panelOptions.activePanel = event.currentIndex;
			} else if (this.panelOptions.activePanel !== -1) {
				moveItemInArray(this.panels, event.previousIndex, event.currentIndex);
				for (let i = 0; i < this.panels.length; i++) {
					if (this.panels[i].open) {
						this.panelOptions.activePanel = i;
						break;
					}
				}
				return;
			}
			moveItemInArray(this.panels, event.previousIndex, event.currentIndex);
		} else {
			console.log(event);
			this.undockPane(event.previousIndex, event.distance);
		}
	}

	undockPane(i: number, customPosition?: {x: number; y: number}) {
		let boundaries = document.getElementById("paneContainer" + i).getBoundingClientRect();
		let newLeftValue;
		let newTopValue;
		if (!customPosition) {
			newLeftValue = boundaries.left + 10;
			newTopValue = boundaries.top + 10;
		} else {
			newLeftValue = boundaries.left + customPosition.x;
			newTopValue = boundaries.top + customPosition.y;
		}

		this.panels[i].undockedPos.left = newLeftValue;
		this.panels[i].undockedPos.top = newTopValue;
		this.panels[i].undockedSize.width = boundaries.width;

		this.panels[i].undockedSize.height = 400;

		if (this.panelOptions.activePanel === i) {
			this.panelOptions.activePanel = -1;
		}

		this.panels[i].undocked = true;
		this.panelOptions.activeUndockedPanel = i;
	}
}
